import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { VariantService } from './varian-service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'variant',
  standalone: true,
  imports: [CommonModule, FormsModule,MatIconModule],
  templateUrl: './variant.html',
  styleUrls: ['./variant.scss']
})
export class Variant implements OnInit {

  searchText: string = '';
  selectedFuel: 'Petrol' | 'Diesel' | 'CNG' = 'Petrol';
  variantListPetrol: any[] = [];
  variantListDiesel: any[] = [];
  variantListCNG: any[] = [];

  selectedMake!: string;
  selectedModel!: string;
  selectedYear!: string;
  rowKey!: string;
  loading: boolean = false;

  constructor(
    private router: Router,
    private variantService: VariantService
  ) {}

  ngOnInit(): void {
    this.loading = true;

    this.selectedMake = localStorage.getItem('newMake') || localStorage.getItem('selectedMake')!;
    this.selectedModel = localStorage.getItem('newModel') || localStorage.getItem('selectedModel')!;
    this.selectedYear = localStorage.getItem('newYear') || localStorage.getItem('selectedYear')!;
    this.rowKey = localStorage.getItem('newRowKey') || localStorage.getItem('rowKey')!;

    this.getVariantData(this.rowKey, this.selectedYear);
  }

getVariantData(rowKey: string, year: string) {
  this.variantService.getVariants(rowKey, year).subscribe(result => {
    this.loading = false;
    const res: any = result;

    if (!res.data || res.data.length === 0) {
      this.variantListPetrol = [];
      this.variantListDiesel = [];
      this.variantListCNG = [];
      return;
    }

    // Reset lists
    this.variantListPetrol = [];
    this.variantListDiesel = [];
    this.variantListCNG = [];

    res.data.forEach((item: any) => {
      if (item.fuelType === 'Petrol') this.variantListPetrol.push(item);
      if (item.fuelType === 'Diesel') this.variantListDiesel.push(item);
      if (item.fuelType === 'CNG') this.variantListCNG.push(item);
    });
  }, error => {
    this.loading = false;
    console.error('Error fetching variants:', error);
    this.variantListPetrol = [];
    this.variantListDiesel = [];
    this.variantListCNG = [];
  });
}



  selectVariant(variantKey: any, variant: any, fuelType: any): void {
  localStorage.setItem('fuelType', fuelType);
  localStorage.setItem('variant', variant);
  localStorage.setItem('variantKey', variantKey);

  if (localStorage.getItem('jobcard') === '1') {
    this.router.navigate(['/my-job-cards']);
  } else if (localStorage.getItem('customer-list') === '1') {
    this.router.navigate(['/customer-list']);
  } else if (localStorage.getItem('spare-kit') === '1') {
    this.router.navigate(['/spare-kit-list']);
  } else if (localStorage.getItem('instantOrder') === '1') {
    localStorage.setItem('instantOrder', '2');
    this.router.navigate(['/home']);
  } else {
    const isFindMyCar = localStorage.getItem("isFindMyCar");
    if (isFindMyCar !== "1") {
      localStorage.setItem('selectedSparesList', JSON.stringify({
        name: `${localStorage.getItem('selectedMake')} ${localStorage.getItem('selectedModel')}`,
        type: 'allSpares',
        imageUrl: "",
        key: ""
      }));
    }
    // 👇 changed from spare-parts-list to estimate-list
    this.router.navigate(['/estimate-list']);
  }
}


  selectFuel(fuel: 'Petrol' | 'Diesel' | 'CNG') {
    this.selectedFuel = fuel;
  }

get filteredVariants() {
  let list: any[] = [];
  if (this.selectedFuel === 'Petrol') list = this.variantListPetrol;
  if (this.selectedFuel === 'Diesel') list = this.variantListDiesel;
  if (this.selectedFuel === 'CNG') list = this.variantListCNG;

  return list.filter(v => v.title && v.title.toLowerCase().includes((this.searchText || '').toLowerCase()));
}


  clearSearch() {
    this.searchText = '';
  }
   goToYear() {
    this.router.navigate(['year']);
  }
}
